/******************************************************************************

Copyright (c) 2020-2021, Visual Elements

******************************************************************************/

// @format

/** Register/Link licence form
 * User can register or link their account from this component
 *
 */

import { cr, ap, on, setStyle } from './../core/highed.dom';
import Events from './../core/highed.events';

export default function(parent) {
  const container = cr('div', 'everviz-cms-register'),
        registerContainer = cr('div', 'everviz-cms-register-container'),
        evervizLogo = cr('img', "everviz-cms-logo-image"),
        registerForm = cr('div', "everviz-cms-register-form"),
        linkAccountContainer = cr('div', "everviz-cms-link-account-container"),
        linkAccountInput = cr('input', "everviz-cms-link-account"),
        registerLink = cr('div', "everviz-cms-register-link", "Register new user"),
        registerNewAccountLink = cr('div', "everviz-cms-register-form new-account"),
        registerNewAccountLinkContainer = cr('div', "everviz-cms-link-account-container new-account"),
        registerNewAccountEmailInput = cr('input', "everviz-login-input"),
        registerNewAccountPasswordInput = cr('input', "everviz-login-input"),
        registerNewAccountButton = cr('button', "everviz-button red", "Register"),
        evervizSpinner = cr('div', "everviz-linking-spinner", '<i class="fa fa-spinner fa-spin"/>'),
        evervizBackButton = cr('div', "everviz-back-button", '<i class="fa fa-chevron-left"/>'),
        evervizErrorMessage = cr('div', "everviz-plugin-error-message"),
        events = Events();
  
  setStyle(evervizErrorMessage, {
    display: 'none'
  });

  let modalBody = parent;
  evervizLogo.src = locals.logo_image;
  linkAccountInput.placeholder = 'Paste your license key here';
  registerNewAccountEmailInput.placeholder = 'Email';
  registerNewAccountPasswordInput.placeholder = 'Password';
  registerNewAccountPasswordInput.type = 'password';

	function verifyLicense(license) {
		return highed.api.verifyLicense(license)
		.then((data) => {
			return data;
		}).catch(err => {
      throw err;
    });
  }

  function showError(err){
    if (err) {
      evervizErrorMessage.innerHTML = err;
      setStyle(evervizErrorMessage, {
        display: 'block'
      });
    } else {
      setStyle(evervizErrorMessage, {
        display: 'none'
      });
    }
  }

  function registerUser(){

    const emailInput = registerNewAccountEmailInput.value, 
          passwordInput = registerNewAccountPasswordInput.value;

		if (emailInput === '') {
			showError("Email required");
			return;
		} else if (passwordInput === '') {
			showError("Password required");
			return;
    } else showError(false);
    
    show(modalBody, false, true);

		highed.api.registerUser(emailInput, passwordInput)
		.then((data) => {
			if (data.license) {
				locals.everviz_license = data.license;
				locals.everviz_team = data.team_id;

				highed.api.setLicenseAndTeam(data.license, data.team_id, locals.rest_url)
				.then(() => {
          highed.api.updateAPILicenseAndTeam(data.license, data.team_id);
          showError(false);
          events.emit("LinkedAccount");
				}).catch((e) => {
					throw e;
				});
			}
		}).catch((err) => {
      showError('Unable to register');
      show(modalBody, true, false);
		})
  }

  
  function attachEvents(){
    on([registerNewAccountEmailInput, registerNewAccountPasswordInput], 'keyup', () => {
      showError(false);
    });
  
    on(evervizBackButton, 'click', () => {
      showError(false);
      modalBody.innerHTML = '';
      show(modalBody, false);
    })
  
    on(registerLink, 'click', () => {
      showError(false);
      modalBody.innerHTML = '';
      show(modalBody, true);
    })
    on(registerNewAccountButton, 'click', () => {
      registerUser();
    });
    on(linkAccountInput, 'paste', (e) => {
      showError(false);
      show(modalBody, false, true);

      const val = e.clipboardData.getData('Text');
      verifyLicense(val)
      .then(data => {
        locals.everviz_license = val;
        locals.everviz_team = data.team_id;

        highed.api.setLicenseAndTeam(val, data.team_id, locals.rest_url)
        .then(() => {
          showError(false);
          events.emit("LinkedAccount");
        }).catch(err => {
          throw err;
        });
      }).catch(err => {
        showError('Unable to verify license');
        show(modalBody, false, false);
      });
    });
  }

  function toggleElements(registerNewAccountProp, registerFormProp, backButtonProp, spinnerProp) {
    setStyle(registerNewAccountLink, {
      display: registerNewAccountProp
    });
    setStyle(registerForm, {
      display: registerFormProp
    });
    setStyle(evervizBackButton, {
      display: backButtonProp
    });
    setStyle(evervizSpinner, {
      display: spinnerProp
    })
  }
  function show(parent = modalBody, showRegisterForm=false, loading=false) {
    
    if (loading) {
      toggleElements('none', 'none', 'none', 'block');
    } else if (showRegisterForm) {
      toggleElements('block', 'none', 'block', 'none');
    } else {
      toggleElements('none', 'block', 'none', 'none');
    }

    ap(parent, container);
    ap(parent, evervizBackButton, evervizErrorMessage);
    modalBody = parent;
  }

  attachEvents()

  ap(registerContainer, evervizLogo);
  //if (showRegisterForm) {
    ap(registerNewAccountLink, 
      ap(registerNewAccountLinkContainer, 
        registerNewAccountEmailInput, 
        registerNewAccountPasswordInput, 
        registerNewAccountButton
      )
    );
    ap(registerContainer, registerNewAccountLink);
  //} else {

    ap(registerForm, 
      ap(linkAccountContainer, 
        linkAccountInput
      ),
      registerLink
    );
    ap(registerContainer, registerForm);
  //}
  ap(registerContainer, evervizSpinner);
  ap(container, registerContainer)

  ///////////////////////////////////////////////////////////////////////////

  return {
    //editor: editor,
    show,
    on: events.on
  };
};
